module.exports = __webpack_public_path__ + "static/media/tuttorisparmio_clientLogo.ce3e6a71.png";